import type { FaireProductEntity } from "../../entity_types/product";

export const p_caryztwwjp: FaireProductEntity = {
  token: "p_caryztwwjp",
  type: "product",
  name: "BigMouth 'Shroom' Cat Bowl",
  brandToken: "b_6qajwqdzz3",
  brandName: "BigMouth Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/6aaf277fdbd87c92fcbc02499885d5b8868382929ec364301d3f0f085b217b2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6620683e7ea3673de093911edab0ea156c5c77abc75ca32d14ce5a0b3021d002.jpeg",
    "https://cdn.faire.com/fastly/5ab3451cf28b5e4c289d82e30a6413edff2fc24ea79497dc582abe6deb81a1f2.jpeg",
    "https://cdn.faire.com/fastly/7596255df936f785bb20413c9ef36994c6e17970750cf770e9c1ab83c657829b.jpeg",
  ],
  priceDollars: 10.38,
  description:
    "There's not 'mushroom' for anything besides pet food in this elevated mushroom bowl! This colorful bowl is the perfect edition to your furry friend's dinner time and acts as an adorable accessory for around the house. This elevated bowl features a bright, colorful mushroom design, with a textured stem as the base and a red and white polka dot mushroom cap as the bowl. It is made from ceramic, stands 5 inches tall, and can be used for wet or dry food, water, and snacks. This elevated pet bowl is the perfect way to add a touch of whimsy and fun to your furry friend's dinner time. While it is perfect for the furry friend of your own, the food dish also makes a great gift for first time pet owners or someone that wants to treat their pet to a more fun and engaging dining experience.",
  tags: [],
  msrpDollars: 20.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:39.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
